module.exports = __webpack_public_path__ + "static/media/loading_code.21116158.gif";